var map = {
	"./be.svg": 9684,
	"./ch.svg": 7809,
	"./de.svg": 264,
	"./dk.svg": 4926,
	"./fr.svg": 9986,
	"./gb.svg": 1517,
	"./ie.svg": 9849,
	"./is.svg": 784,
	"./lt.svg": 6259,
	"./lu.svg": 320,
	"./nl.svg": 3648,
	"./se.svg": 5316,
	"./xi.svg": 3828
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8945;